<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Report ODS </h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="data"  aria-describedby="conferrals tables">
        <ng-container matColumnDef="id_cli_ods">
          <th mat-header-cell *matHeaderCellDef>
            {{ "custom-report.grid.column.id_cli_ods" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.id_cli_ods }}
          </td>
      </ng-container>
        <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.descrizione" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.descrizione}}
            </td>
        </ng-container>
        <ng-container matColumnDef="stato_completamento">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.stato_completamento" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.stato_completamento }}
            </td>
        </ng-container>
        <ng-container matColumnDef="ts_inizio_reale">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.ts_inizio_reale" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.ts_inizio_reale | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="ts_fine_reale">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report.grid.column.ts_fine_reale"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.ts_fine_reale | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>
            {{ "custom-report.grid.column.city"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.citta_ods }}
          </td>
      </ng-container>
        <ng-container matColumnDef="waste_type">
          <th mat-header-cell *matHeaderCellDef>
            {{ "custom-report.grid.column.waste_type"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-icon svgIcon="glass-icon" aria-hidden="false" aria-label="Glass icon"  matTooltip="VETRO" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('VETRO')"></mat-icon>
            <mat-icon svgIcon="paper-icon"  matTooltip="CARTA" aria-hidden="false" aria-label="Paper icon" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('CARTA')"></mat-icon>
            <mat-icon svgIcon="dry-trash-icon"  matTooltip="SECCO" aria-hidden="false" aria-label="Dry icon" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('SECCO')"></mat-icon>
            <mat-icon svgIcon="green-trash-icon"  matTooltip="VERDE" aria-hidden="false" aria-label="Green icon" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('VERDE')"></mat-icon>
            <mat-icon svgIcon="humid-trash-icon"  matTooltip="UMIDO" aria-hidden="false" aria-label="Humid icon" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('UMIDO')"></mat-icon>
            <mat-icon svgIcon="plastic-trash-icon"  matTooltip="PLASTICA" aria-hidden="false" aria-label="Plastic icon" *ngIf="row.tipologia_rifiuto!== null && row.tipologia_rifiuto.includes('PLASTICA')"></mat-icon>
          </td>
      </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>